module.exports = __webpack_public_path__ + "img/plan10.d2c1346e.svg";